<template>
  <router-view />
</template>

<script>
export default {
  name: 'cadastrosHome',
}
</script>
